import { ICONS } from '@ui/icons/types';
import EmailConfirmationToggle from './email-confirmation-toggle';
import RequireConfirmationToggle from './require-confirmation-toggle';
import SingleUseRegistrationToggle from './single-use-registration-toggle';
import SuppressDuplicatesToggle from './suppress-duplicates-toggle';
import Text from '@ui/text/text/text';
import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';
import { memo } from 'react';
import IconWithBackdrop from '@ui/icons/icon-with-backdrop';

const EmailsRegistrationSettings = memo(() => {
  return (
    <div className="flex-column gap-8">
      <div className="flex ai-center gap-8">
        <Text tag="h5" className="H5">
          Emails
        </Text>
        <TooltipPortal tooltipContent={<Text design="GlobalIcoText1">Registration Email Settings</Text>}>
          <IconWithBackdrop
            name={ICONS.INFO_CIRCLE}
            size={12}
            color="var(--primitives-mode-1-gray-500)"
            backdropColor="var(--primitives-mode-1-gray-100)"
          />
        </TooltipPortal>
      </div>
      <EmailConfirmationToggle />
      <RequireConfirmationToggle />
      <SuppressDuplicatesToggle />
      <SingleUseRegistrationToggle />
    </div>
  );
});

EmailsRegistrationSettings.displayName = 'EmailsRegistrationSettings';

export default EmailsRegistrationSettings;
